import { format } from "date-fns";
import i18n from "i18n-js";
import { DELETE, GET, POST, PUT, downloadBlob } from "../utils/crud";

const buildObservationFormData = (body) => {
  const formData = new FormData();
  formData.append('patient_id', body.patient_id);

  if (body.observation && body.observation.trim().length > 0) {
    formData.append('observation', body.observation.trim());
  }
  if (body.type) {
    formData.append('type', body.type);
  }
  (body.photos || []).forEach((file) => {
    formData.append('photos[]', file);
  });

  return formData;
};

export const createObservation = async (body) => {
  const formData = buildObservationFormData(body);
  return await POST("observations", formData, true, { Accept: 'multipart/form-data' });
}
export const updateObservation = async (body, id) => await PUT(`observations/${id}`, body)
export const getObservationPhoto = async (observationId, photoId) =>
  await downloadBlob(`observations/${observationId}/photos/${photoId}`)
export const getObservationList = async (payload) => {
  const params = new URLSearchParams();

  // 👇 solo agregamos si existen
  if (payload?.patient?.id) {
    params.append("patient_id", String(payload.patient.id));
  }

  if (payload?.staff?.id) {
    params.append("created_by", String(payload.staff.id));
  }

  if (payload?.start) {
    params.append("created_at_from", format(new Date(payload.start), i18n.t('general.dateFormatFirstYear')));
  }

  if (payload?.end) {
    params.append("created_at_to", format(new Date(payload.end), i18n.t('general.dateFormatFirstYear')));
  }

  const queryString = params.toString();
  const url = queryString ? `observations?${queryString}` : "observations";
  const response = await GET(url)
  return response;
};
export const getObservationTypes = async () => await GET("observation-types")
export const deleteObservationList = async (id) => await DELETE(`observations/${id}`)